export default __webpack_public_path__ + "static/media/Group 6345.d22300a9.svg";